<ul class="property-block__list">
    <li class="property-block__list-item">
        <div class="property-block__label" id="inheritRentalReturns">Inherit Rental Returns</div>
        <div class="property-block__value" role="definition" aria-labelledby="inheritRentalReturns">{{ district.inheritRentalReturns | yesNo }}</div>
    </li>
    <li class="property-block__list-item">
        <div class="property-block__label" id="returnsBlackoutPeriod">Returns Blackout Period</div>
        <div class="property-block__value" role="definition" aria-labelledby="returnsBlackoutPeriod">{{ district.hasBlackoutPeriod | yesNo }}</div>
    </li>
    <ng-container *ngIf="district.hasBlackoutPeriod">
        <li class="property-block__list-item">
            <div class="property-block__label" id="blackoutPeriodStart">Blackout Period</div>
            <div class="property-block__value" role="definition" aria-labelledby="blackoutPeriodStart">{{ blackoutPeriod }}</div>
        </li>
    </ng-container>
</ul>
